import { useTranslation } from 'react-i18next';
import type { KpiMetric } from '@/types/reports';
import { useKpiCardStyles } from './KpiCard.styles';
import { StarRating } from '../StarRating';

interface KpiCardProps {
  metric: KpiMetric;
}

export function KpiCard({ metric }: KpiCardProps) {
  const styles = useKpiCardStyles();
  const { t } = useTranslation('reports');

  const trendClass =
    metric.trendDirection === 'positive'
      ? styles.trendPositive
      : metric.trendDirection === 'negative'
        ? styles.trendNegative
        : styles.trendNeutral;

  const trendText = metric.trendValue ?? metric.trendLabel ?? '—';

  return (
    <section className={styles.root} aria-label={t(metric.labelKey)}>
      <span className={styles.label}>{t(metric.labelKey)}</span>
      <span className={styles.value}>
        {metric.value}
        {metric.subtitle && <span className={styles.subtitle}>{metric.subtitle}</span>}
      </span>
      {metric.ratingValue != null && <StarRating value={metric.ratingValue} />}
      <span className={trendClass}>{trendText}</span>
    </section>
  );
}
